import { Client } from 'urql';
import { statePageQuery } from './statePageQuery';

export const fetchStatePage = async ({ client, slug }: { client: Client; slug: string }) => {
  const { data, error } = await client.query(statePageQuery, { slug }).toPromise();
  return { data, error };
};
